import { combineReducers } from "redux";
import { PHCOnboardingReducer } from "./PHCOnboarding/PHCOnboardingReducer";
import PHCDashboardReducer from "./PHCDashoard/PHCDashboardReducer";

const PHCRootReducer = combineReducers({
    PHCOnboarding: PHCOnboardingReducer,
    PHCDashboard:PHCDashboardReducer
});

export { PHCRootReducer };
